import { state } from './types';

export default {
  [state.DATASETS]: [],
  [state.IS_LOADING]: false,
};
